import React, { useMemo } from 'react';
import { GroupedProcess, PlanFactTree } from "@baseTypes/service/dashboard/IWorksDashboardService";
import GroupedWorkItem
    from "@pages/dashboard/works/byDepartmentsAndCrops/components/processByDepartment/components/GroupedWorkItem/GroupedWorkItem";
import WorkItem from '@pages/dashboard/works/components/WorkItem/WorkItem';
import { isEmpty } from 'lodash';

type ProcessByDepartmentProps = {
    data: GroupedProcess['progressByDepartment']
    openedGroups: number[]
    setOpenedGroups: (groupIds: number[]) => void
    barsSize: number
}

const ProcessByDepartment = (props: ProcessByDepartmentProps) => {
    const { data, setOpenedGroups, openedGroups, barsSize } = props;

    const listConvertedFromTreeWorksByDepartment: React.ReactNode[] = useMemo(() => {
        if (!data) return []

        const buildNodes = (node: PlanFactTree): React.ReactNode => {
            if (!isEmpty(node.children)) {
                return (
                    <GroupedWorkItem value={node.value}
                                     key={node.value.groupId}
                                     openedGroups={openedGroups}
                                     barsSize={barsSize}
                                     setOpenedGroups={setOpenedGroups}
                    >
                        {node.children.map((child, index) => (
                            <React.Fragment key={`${node.value.groupName}-${index}`}>
                                {buildNodes(child)}
                            </React.Fragment>
                        ))}
                    </GroupedWorkItem>
                )
            } else {
                return <WorkItem key={node.value.groupId}
                                 barsWidth={barsSize}
                                 work={{
                                     season: { cropPeriods: [], cultivatedArea: node.value.season.fact, totalArea: node.value.season.plan },
                                     today: { cropPeriods: [], cultivatedArea: node.value.today.fact, totalArea: node.value.today.plan },
                                     displayName: node.value.groupName || ''
                                 }}
                                 // chevron + gap = 36, left margin (in GroupedWorkItem) = 32, need to be equals
                                 style={{ paddingLeft: 4 }}
                                 type={'group'} />
            }
        };

        return [buildNodes(data)];
    }, [data, openedGroups])
    return listConvertedFromTreeWorksByDepartment
}

export default ProcessByDepartment;